import React from "react";
import loading from "../../assets/images/loading.gif";
import "../../assets/styles/components/loading.scss";

export default function Loading(props) {
    return (
        <div className={`wrap-loading ${props.show ? "slide-up" : "slide-down"}`}>
            <img src={loading} width={250} height={250}/>
            <p className="mt-4 h5" style={{color: "#1062d0"}}>
                در حال دریافت اطلاعات...
            </p>
        </div>
    );
}
